import { render, staticRenderFns } from "./digital_edit.vue?vue&type=template&id=641bf215&scoped=true&"
import script from "./digital_edit.vue?vue&type=script&lang=js&"
export * from "./digital_edit.vue?vue&type=script&lang=js&"
import style0 from "./digital_edit.vue?vue&type=style&index=0&id=641bf215&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641bf215",
  null
  
)

export default component.exports